/** ****************************************************************************
 * This constants file has constants for miscellaneous values.
 *
 * @file   Constants file, various types of values.
 * @author Paul J Stales
 * @since  2.0.0
 **************************************************************************** */

/**
 * Values
 */
export const MAGAZINE_IMAGE_HEIGHT = '160px'
export const BPERX_STRING: string = 'BPERX'

/**
 * Message types for the iFrame post messaging and window.onmessage
 */
export const THIRD_PARTY_MESSAGE_TYPE = {
  SUPPRESS_PREACT_DEVTOOLS: 'preact-devtools-to-client',
  SUPPRESS_PREACT_PAGEHOOK: 'preact-page-hook',
  SUPPRESS_WEBPACK_OK: 'webpackOk',
  SUPPRESS_WEBPACK_WARNINGS: 'webpackWarnings',
  SUPPRESS_WEBPACK_INVALID: 'webpackInvalid'
}

/**
 * Types
 */
export const TYPES = {
  OBJECT: 'object',
  STRING: 'string',
  BOOLEAN: 'boolean'
}

/**
 * Opt Checkbox Default Strings
 */
export const OPT_CHECKBOX_STRINGS = {
  OPT_IN: 'Yes, please opt me in!',
  OPT_OUT: 'Please opt me out.'
}
